import React from 'react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.black,
      textAlign: 'left',
      width: '100%',
      display: 'block',
      opacity: 0.5,
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '20px'
    }
  }));

export const ComponentSourcetitle: React.FC<{loading?:boolean}> = (props) => {
  const classes = useStyles(props);
  const {loading, children} = props;
  if (loading) {
    return <Skeleton variant="rect" width={460} height={20} className={classes.root} />
  }
  return (
    <Typography variant="h4" classes={classes}>
      {children}
    </Typography>
  );
}